import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ea7220f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ea7220f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7220f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea7220f0')) {
      api.createRecord('ea7220f0', component.options)
    } else {
      api.reload('ea7220f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ea7220f0&scoped=true", function () {
      api.rerender('ea7220f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationCenter/notice/index.vue"
export default component.exports